export const LOAD_TRANSACTION =
  'app/TransactionDetailContainer/LOAD_TRANSACTION';
export const LOAD_TRANSACTION_SUCCESS =
  'app/TransactionDetailContainer/LOAD_TRANSACTION_SUCCESS';
export const LOAD_TRANSACTION_ERROR =
  'app/TransactionDetailContainer/LOAD_TRANSACTION_ERROR';
